import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrNacConfigurableModule } from './kn-br-nac-configurable/kn-br-nac-configurable.module';
import { RouterModule } from '@angular/router';
import { AuthGuard, ConfigModule, I18nModule, RoutingConfig } from '@spartacus/core';
import { CmsPageGuard, FormErrorsModule, PageLayoutComponent } from '@spartacus/storefront';
import { KnBrUploadNewTemplateDialogComponent } from './kn-br-upload-new-template-dialog/kn-br-upload-new-template-dialog.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KnBrUpdateTemplateDialogComponent } from './kn-br-update-template-dialog/kn-br-update-template-dialog.component';
import { KnBrDownloadConfirmationDialogComponent } from './kn-br-download-confirmation-dialog/kn-br-download-confirmation-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        KnBrNacConfigurableModule,
        FileUploadModule,
        ReactiveFormsModule,
        FormsModule,
        FormErrorsModule,
        I18nModule,
        RouterModule.forChild([
            {
                data: { pageLabel: '/nac', cxRoute: 'nac' },
                path: null,
                canActivate: [AuthGuard, CmsPageGuard],
                component: PageLayoutComponent,
            },
        ]),
        ConfigModule.withConfig({
            routing: {
                routes: {
                    nac: {
                        paths: ['nac'],
                    },
                },
            },
        } as RoutingConfig),
        KnBrUploadNewTemplateDialogComponent,
        KnBrUpdateTemplateDialogComponent,
        KnBrDownloadConfirmationDialogComponent,
    ],
})
export class KnBrNacModule {}
